import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import { DataHandler, SharingPopup } from 'C4';
import { primaryColor, accentColor } from 'config/styles';
import { renderToString } from 'react-dom/server';

let iv = null;

const parseColor = (color) => {
  let newColor = color.substring(1);
  if (newColor.length === 3) {
    newColor += newColor;
  }
  return newColor;
};

const compareImages = (a, b) => {
  const imageName = new RegExp('(?:.(?!/))+.[.]jpg+', 'g'); // NOTE: https://regexr.com/46ee5
  const valid = [a.match(imageName), b.match(imageName)].every(val => val !== null);
  if (valid) {
    const [matchA] = a.match(imageName);
    const [matchB] = b.match(imageName);
    return matchA === matchB;
  }
  return false;
};

const parseSrc = (src, appId) => {
  let newSrc = src;
  const imgExt = ['jpg', 'png', 'bmp'].some(ext => src.includes(`.${ext}`));
  if (!src.includes('http') && imgExt) {
    newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/appChapter/${src}`;
    if (appId > 500) {
      newSrc = `https://front.travpromobile.com/${appId}/${src}`;
    }
  }
  return newSrc;
};

const Gradient = (props) => {
  const { id, customClass } = props;
  return (
    <div
      id={id}
      className={`overlay gradient ${customClass}`}
    />
  );
};

export default class Image extends Component {
  constructor(props) {
    super(props);

    const { height, width } = props.default;

    this.state = {
      appId: this.props.appId,
      image: 'https://front.travpromobile.com/bg/img.jpg',
      id: this.props.src,
      orgUrl: '',
      size: { width, height },
      imageReady: false,
      inViewport: false,
      errorCaught: false,
    };
  }

  componentWillMount() {
    this.mounted = true;
    DataHandler.matchAppId().then((appId) => {
      this.setAbsolute();
      const parsed = parseSrc(this.state.id, this.state.appId);
      const id = parsed.length > 0 ? parsed : this.state.id;

      if (this.state.appId === -1 && this.mounted) {
        this.setState({ appId, id, inViewport: this.inViewport() });
      } else this.setState({ id, inViewport: this.inViewport() });
    });

    document.addEventListener('scroll', () => {
      if (this.mounted) {
        this.setState({ inViewport: this.inViewport() });
      }
    });

    document.body.addEventListener('click', () => {
      if (this.mounted) {
        this.setState({ inViewport: this.inViewport() });
      }
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resize);
      if (this.mounted) {
        this.resize = setTimeout(() => {
          this.getSize(() => {
            this.updateImage(true);
          });
        }, 50);
      }
    });
  }

  componentDidMount() {
    this.getSize();
  }

  componentDidUpdate() {
    const {
      appId,
      imageReady,
      image,
      inViewport,
    } = this.state;

    const { src, staticImage } = this.props;

    const mainCondition = (imageReady && appId > 0 && !image.includes('imgix.net') && inViewport && this.mounted);

    if ((!compareImages(image, src) && !image.includes('placeholder')) && !staticImage) {
      const name = new RegExp('(?:.(?!/))+.[.]jpg+', 'g'); // NOTE: https://regexr.com/46ee5
      const folder = new RegExp(`(?:${appId})/.+/`, 'g'); // NOTE: https://regexr.com/46eeb
      let newImage = image.replace(image.match(name), src.match(name));
      newImage = newImage.replace(image.match(folder), src.match(folder));
      this.setState({ image: newImage });
    }

    if (mainCondition) {
      this.updateImage();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    clearInterval(iv);
    document.removeEventListener('scroll', () => {
      if (this.mounted) {
        this.setState({ inViewport: this.inViewport() });
      }
    });

    document.body.removeEventListener('click', () => {
      if (this.mounted) {
        this.setState({ inViewport: this.inViewport() });
      }
    });
  }

  getSize(callback) {
    const { id, size } = this.state;
    const image = document.getElementById(id).parentElement;
    if (image.clientWidth !== undefined && this.mounted) {
      this.setState({
        size: {
          width: Math.floor((image.width > 400) ? image.clientWidth : size.width),
          height: Math.floor((image.clientHeight > 400) ? image.clientHeight : size.height),
        },
      }, () => {
        if (callback !== undefined) {
          callback();
        }
      });
    } else console.warn('Image was undefined during load');
  }

  setAbsolute() {
    const { id } = this.state;
    return new Promise((resolve) => {
      const loader = document.getElementById(id).parentElement.children[1];
      iv = setInterval(() => {
        if (loader !== undefined) {
          clearInterval(iv);
          loader.style.position = 'absolute';
          loader.style.left = 0;
          loader.style.right = 0;
          resolve();
        }
      }, 100);
    });
  }

  inViewport() {
    const { id, size } = this.state;
    const { height, width } = size;
    const imageElement = document.getElementById(id);

    if (imageElement !== null) {
      const img = imageElement.getBoundingClientRect();
      return (
        img.top >= 0 &&
        img.left >= 0 &&
        img.bottom <= (window.innerHeight || document.documentElement.clientHeight) + (height * 2) &&
        img.right <= (window.innerWidth || document.documentElement.clientWidth) + (width * 2)
      );
    }
    return false;
  }

  catchError() {
    const { id, size, errorCaught } = this.state;
    const { customErrorText } = this.props;
    if (!errorCaught && this.mounted) {
      this.setState({ image: id, errorCaught: true });
    } else {
      // const errorText = encodeURIComponent(i18n.translate('imageNotFound')); TODO: Change back to 'Image not Found'
      const errorText = encodeURIComponent(customErrorText || 'Image not found');
      const background = parseColor(primaryColor);
      const text = parseColor(accentColor);
      if (this.mounted) {
        this.setState({ image: `https://via.placeholder.com/${size.width}x${size.height}/${background}/${text}/?text=${errorText}` });
      }
    }
  }

  updateImage(forcedUpdate) {
    const {
      appId,
      id,
      image,
      size,
      errorCaught,
    } = this.state;
    const { href, minWidth } = this.props;

    const width = size.width > 100 ? size.width : minWidth;

    const { type, fit, resize } = this.props;
    if ((!image.includes('imgix.net') && !errorCaught) || forcedUpdate) {
      const imagePath = id.substring(id.indexOf(appId) + appId.toString().length + 1);
      const sizeParams = `w=${type === 'w' ? width : 'auto'}&h=${type === 'h' ? size.height : 'auto'}`;
      const params = `${imagePath.includes('?') ? '&' : '?'}fit=${fit}&${resize ? sizeParams : ''}`;
      if (this.mounted) {
        if (appId > 500) {
          this.setState({
            image: `https://travprocdn.imgix.net/${appId}/${imagePath}`,
            orgUrl: href,
          });
        } else {
          this.setState({
            image: `https://travpromobileimages.imgix.net/apptool/app/${appId}/${imagePath}${params}`,
            orgUrl: href,
          });
        }
      }
    }
  }

  flagReady() {
    const { imageReady } = this.state;
    if (!imageReady && this.mounted) {
      this.getSize();
      this.setState({ imageReady: true });
    }
  }

  render() {
    const {
      id,
      image,
      imageReady,
      errorCaught,
      orgUrl,
    } = this.state;
    const {
      alt, load, gradient, className, fancybox, cover, children, stylingOverride, caption,
    } = this.props;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'y',
      },
      buttons: ['share', 'close'],
      caption,
      share: {
        tpl: renderToString(<SharingPopup url={orgUrl} image={orgUrl} title={alt} />),
      },
    };

    const transition = 'all 0.5s';
    const opacity = (!imageReady ? 0 : 1);
    const absolute = (!imageReady ? { position: 'absolute', left: 0, right: 0 } : {});
    const flex = (!imageReady ? { display: 'flex', alignItems: 'center', height: '0' } : {});
    const covered = (cover && { width: '100%', height: '100%' });

    const parentDivStyles = Object.assign(flex, covered);

    return (
      <div style={stylingOverride || parentDivStyles}>
        <img
          id={id}
          src={image}
          alt={alt}
          className={className || null}
          style={{ transition, opacity }}
          onLoad={() => {
            if (!errorCaught) {
              this.flagReady();
              load();
              this.updateImage();
            }

            if (image.includes('imgix')) {
              // console.info(`Loaded: ${image}`);
            }
          }}
          onError={e => this.catchError(e)}
          data-fancybox={fancybox}
          data-options={JSON.stringify(fancyOptions)}
          data-caption={caption}
          href={orgUrl}
          // data-fancybox-download={orgUrl}
          //         data-type={fancybox.endsWith('.pdf') ? 'iframe' : null}
        />
        <BeatLoader
          style={absolute}
          loading={!imageReady}
        />
        {gradient &&
          <Gradient
            id={id}
          />}
        {children !== undefined && children}
      </div>
    );
  }
}


Image.propTypes = {
  alt: PropTypes.string,
  appId: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  className: PropTypes.string,
  cover: PropTypes.bool,
  customErrorText: PropTypes.string,
  default: PropTypes.shape({ height: PropTypes.number, width: PropTypes.number }),
  fancybox: PropTypes.string,
  fit: PropTypes.string,
  gradient: PropTypes.bool,
  href: PropTypes.string,
  load: PropTypes.func,
  options: PropTypes.shape(),
  resize: PropTypes.bool,
  src: PropTypes.string.isRequired,
  staticImage: PropTypes.bool,
  stylingOverride: PropTypes.shape(),
  type: PropTypes.string,
  minWidth: PropTypes.number,
};

Image.defaultProps = {
  alt: '',
  appId: -1,
  children: null,
  className: null,
  cover: false,
  customErrorText: '',
  default: { width: 650, height: 650 },
  fancybox: null,
  fit: 'clip',
  gradient: false,
  href: '',
  load: () => { },
  options: null,
  resize: true,
  staticImage: true,
  stylingOverride: null,
  type: 'w',
  minWidth: 800,
};

Gradient.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customClass: PropTypes.string,
};

Gradient.defaultProps = {
  id: `gradient_${Date.now()}`,
  customClass: '',
};
